// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { NotificationsCounterChangedEvent } from '@shared/utils/Notifications/NotificationsCounterChangedEvent';
import { DataCache } from '@shared/commons/DataCache';
import { TerceraSideBarButton } from './SideBar/TerceraSideBarButton';
import { ControlsTypes } from '../UtilsClasses/FactoryConstants';
export class NotificationsButton extends TerceraSideBarButton {
    constructor() {
        super();
        this.tooltipKey = 'panel.Notifications.tt';
        this.isUnreadIDs = null;
    }
    getType() {
        return ControlsTypes.NotificationsButton;
    }
    oncomplete() {
        super.oncomplete();
        DataCache.OnBMCounterMsgReceived.Subscribe(this.OnBMCounterMsgReceived, this);
    }
    dispose() {
        DataCache.OnBMCounterMsgReceived.UnSubscribe(this.OnBMCounterMsgReceived, this);
        super.dispose();
    }
    onReadMsg(bmID) {
        if (this.isUnreadIDs[bmID]) {
            this.isUnreadIDs[bmID] = false;
            this.decrementCounter();
        }
    }
    OnBMCounterMsgReceived(bmIDs, action = NotificationsCounterChangedEvent.NewArr) {
        if (!bmIDs) {
            return;
        }
        if (action === NotificationsCounterChangedEvent.RemoveOne) {
            // only one BM id with RemoveOne action means that BM was read
            this.onReadMsg(bmIDs);
            return;
        }
        if (action === NotificationsCounterChangedEvent.AddOne) {
            // only one BM id with AddOne action means that new unread BM has come
            if (this.isUnreadIDs && !this.isUnreadIDs[bmIDs]) {
                this.isUnreadIDs[bmIDs] = true;
                void this.set('counter', (this.get('counter') || 0) + 1);
            }
            return;
        }
        const result = {};
        let count = 0;
        for (let i = 0; i < bmIDs.length; i++) {
            if (!result[bmIDs[i]]) {
                count++;
                result[bmIDs[i]] = true;
            }
        }
        this.isUnreadIDs = result;
        this.onCounterNumberChanged(count);
    }
    onCounterNumberChanged(unreadQty) {
        // if (unreadQty > 0) {
        //     this.startCounterBlinking();
        // }
        void this.set('counter', unreadQty);
    }
    decrementCounter() {
        const oldValue = this.get('counter');
        if (!oldValue) {
            // can't be less than zero
            return;
        }
        void this.set('counter', oldValue - 1);
    }
}
TerceraSideBarButton.extendWith(NotificationsButton, {});
